<template>
  <li class="treeRow">
    <div class="treeNode" :style="{'padding-left': (14 * level) + 'px'}"
         :class="[{treeOpen: data.open}, {treeSingle: !(data.children && data.children.length > 0)}, {treeCur: (currentNodeId && (data.id === currentNodeId || data.routerName === currentNodeId))}]"
         @click="handleTreeNodeClick(data)">
      <div class="treeNodeIn">
        <span class="treeNode-arr"><i class="mng icon-arrRight-fill"></i></span>
        <span class="treeNode-ico"><i class="mng icon-tree-file-stroke"></i></span>
        <a href="javascript:" class="treeNode-txt">{{ data.name }}</a>
      </div>
    </div>
    <el-collapse-transition>
      <div class="treeContent" v-show="data.open" v-if="data.children && data.children.length > 0">
        <ul>
          <sub-tree-row
            v-for="(item, i) in data.children"
            v-show="item.show === undefined || item.show"
            :key="i"
            :data="item"
            :level="level + 1"
            @node-click="handleTreeNodeClick"
          >
          </sub-tree-row>
        </ul>
      </div>
    </el-collapse-transition>
  </li>
</template>
<script>
//  import {STORE_APP_MUTATION_TYPES} from '../../libs/constants'

  export default {
    name: 'sub-tree-row',
    props: {
      data: {
        type: Object,
        default() {
          return {}
        }
      },
      level: {
        type: Number
      }
    },
    computed: {
      currentNodeId: function () {
        return this.$store.state.app.currentLeftMenuId
      }
    },
    methods: {
      handleTreeNodeClick(node) {
        this.$emit('node-click', node)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/left-menu/sub-tree-row.vue